import {
    DefaultButton, IDropdownOption,
    IPanelProps,
    IRenderFunction,
    Panel,
    PanelType,
    PivotItem,
    PrimaryButton, Separator
} from '@fluentui/react';
import { RootState } from 'app/store';
import CESDropdown from 'components/controls/CESDropdown';
import ControlMask from 'components/controls/ControlMask';
import DropdownControl from 'components/controls/DropdownControl';
import LookupControlBase from 'components/controls/LookupControlBase';
import SectionItem, { ESectionItemVariant } from 'components/controls/SectionItem/Index';
import TextFieldControl from 'components/controls/TextFieldControl';
import ToggleControl from 'components/controls/ToggleControl';
import { useApplication } from 'global/Application/Context';
import { TChangeTracker } from 'global/EmitEvent/Delta';
import { ArrayToMapByPredicateWithMap } from 'global/Utility/TSFunctions';
import { BuildVisibilityScope, applyVisibility } from 'global/Visibility/GlobalVisibility';
import { IFieldReference } from 'global/Visibility/IFieldReference';
import { IVisibilityScope } from 'global/Visibility/IVisibilityScope.type';
import { ParentVisibilityGraphProcessor } from 'global/Visibility/ParentVisibilityGraph';
import { bcbs_config_masterattribute } from 'model/AttributeOptionSets.type';
import {
    EBenefitStatus as FAM_EBenefitStatus,
    IAccountsReceivable as FAM_IAccountsReceivable,
    IGroupNumber as FAM_IGroupNumber,
    IPlan as FAM_IPlan,
    TBenefitStatusOptionSetValue as FAM_TBenefitStatusOptionSetValue,
    TValue as FAM_TValue
} from 'model/FlexibleAttributeModel';
import { IGroupConfigurationData } from "model/FlexibleAttributeModel";
import { useEffect, useMemo, useState } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { CalculateRunOutClaimsEndDate, CancellationFieldsByCategory, EViewType, fadeIn, friendlyValueToFlexibleFieldValue, panelButtonsStyles } from "../../global/Application";
import AccountsReceivableWizard from './AccountsReceivableWizard';
import FlexibleFieldView, { EScopeType } from './FlexibleFieldView';
import PlanWizard from './PlanWizard';
import StopLossWizard from './StopLossWizard';
import { $cat_$group_number_id } from "model/ConfigCategoryConstants";

interface IProps extends TComponentConnectedProps {
    onPick?: (index: number) => void;
    snap?: IGroupConfigurationData;

    // if provided, filters display grid to only referenced for this plan
    currentPlan?: FAM_IPlan;

    // if provided, filters display grid to only referenced for this accounts receivable
    currentAR?: FAM_IAccountsReceivable;

    disabled?: boolean;

    onChange?: (groupNumber: FAM_IGroupNumber | null) => void;

    defaultValue?: FAM_IGroupNumber;

    isOpen: boolean;

    onDismiss?: () => void;

    visibility?: IVisibilityScope;
}

const GroupStructureGroupNumberView = (props: IProps) => {

    const application = useApplication();

    // allows the component to perform a local visibility management, to help with the animation and ui smoothness
    // by default this should always be visible unless components has signaled a context job termination and wants to self close
    const [selfVisible, setSelfVisible] = useState(true);

    const [groupNumber, setGroupNumber] = useState<FAM_IGroupNumber | null>(props.defaultValue
        ? props.defaultValue
        : null
    );

    const [changeTracker, setChangeTracker] = useState<TChangeTracker>({});

    useEffect(() => {
        if (props.isOpen) {

            setSelfVisible(true);

            setChangeTracker({});

            if (props.defaultValue)
                setGroupNumber(t => {
                    const value = structuredClone(props.defaultValue)!;

                    if (value?.id === 'bulk') {

                        //@ts-ignore
                        delete value.cesNumberRef;

                        //@ts-ignore
                        delete value.deactivated;

                        //@ts-ignore
                        delete value.status;
                    }

                    return value
                });
        }

    }, [props.isOpen, props.defaultValue])

    const parentVisibilityProcessor = useMemo(() => {
        const gProcessor = new ParentVisibilityGraphProcessor(
            props.state.data.config,
            props.state.data.config.cache.parentVisibilityGraph
        );

        return gProcessor;
    }, []);

    const categoryGroupStructure = props.state.data.config.cache.map_bcbs_config_category_named['Group Number'];

    const statusOptions = useMemo(() => {
        return props.state.data.config.cache.options_benefitStatusReasons;
    }, []);

    const isBulk = groupNumber?.id === 'bulk';

    const [isPlanOpen, setIsPlanOpen] = useState(false);
    const [isAROpen, setIsAROpen] = useState(false);
    const [isStopLossOpen, setIsStopLossOpen] = useState(false);

    const onDismiss = () => {
        props.onDismiss?.();
    }

    function calcGroupNumber(prefix: string | null | undefined, base: string | null | undefined, suffix: string | null | undefined) {

        return `${prefix ?? ''}-${base ?? ''}-${suffix ?? ''}`;
    }

    const onRenderBody: IRenderFunction<IPanelProps> = (bodyProps, defaultRender) => {
        return <div>
            <Separator />

            <PlanWizard

                isOpen={isPlanOpen}
                onDismiss={() => { setIsPlanOpen(false) }}
                onCancel={() => { setIsPlanOpen(false) }}
                onConfirm={(event) => {
                    setGroupNumber(t => {
                        const n = { ...t! };

                        n.planRef = event?.value?.planSelected
                            ? {
                                id: event.value.planSelected.id!,
                                name: event.value.planSelected.name!
                            }
                            : undefined;

                        return n;
                    });
                }}
                variant="pick"
            />

            <AccountsReceivableWizard
                isOpen={isAROpen}
                onDismiss={() => { setIsAROpen(false); }}
                onCancel={() => { setIsAROpen(false); }}
                variant="pick"
                onConfirm={(event) => {

                    debugger;

                    setGroupNumber(t => {
                        const n = { ...t! };

                        n.accountsReceivableRef = event?.value?.ARSelected
                            ? {
                                id: event.value.ARSelected.id!,
                                name: event.value.ARSelected.name!
                            }
                            : undefined;

                        return n;
                    });

                    setIsAROpen(false);
                }}
            />

            <StopLossWizard
                isOpen={isStopLossOpen}
                onDismiss={() => { setIsStopLossOpen(false); }}
                onCancel={() => { setIsStopLossOpen(false); }}
                variant="pick"
                onConfirm={(event) => {

                    setGroupNumber(t => {
                        const n = { ...t! };

                        n.stopLossRef = event?.value.stopLossSelected
                            ? {
                                id: event.value.stopLossSelected.id!,
                                name: event.value.stopLossSelected.name!
                            }
                            : undefined;

                        return n;
                    });

                    setIsStopLossOpen(false);
                }}
            />

            <FlexibleFieldView
                disabled={props.state.status.viewType === EViewType.ViewOnly || props.disabled}
                fields={groupNumber?.fields!}
                category={categoryGroupStructure}
                tiers={[]}
                bulk={groupNumber?.id === 'bulk'}
                cancellation={groupNumber?.status?.value === FAM_EBenefitStatus.Cancelled}
                scope={groupNumber}
                visibility={BuildVisibilityScope(
                    null,
                    props.state.data.json,
                    null,
                    null,
                    groupNumber,
                )}
                scopeType={EScopeType.groupNumber}
                onChange={(changeEvent) => {
                    if (changeEvent.field) {

                        // TODO used in emit event, but it really should change approach to compare and generate change tracker performing a delta before & after
                        setChangeTracker(t => {
                            const c = { ...t };
                            c[changeEvent.field?.configRef.id!] = {
                                field: changeEvent.field!,
                                fieldValue: changeEvent.fieldValue!,
                                value: changeEvent.value!,
                            }
                            return c;
                        });

                        setGroupNumber(xGroupNumber => {
                            const nGroupNumber = { ...xGroupNumber! };

                            // Lookups --------------------------------------
                            const fields = nGroupNumber.fields!;
                            const field = nGroupNumber.fields?.find(q => q.id === changeEvent.field!.id)!;
                            const fieldsMap = ArrayToMapByPredicateWithMap(fields, eField => eField.configRef.id, (eField, index) => {
                                const attribute = props.state.data.config.cache.map_bcbs_config_attribute[eField.configRef.id];
                                const masterAttribute = props.state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                                const ret: IFieldReference = {
                                    index: index,
                                    field: eField,
                                    attribute: attribute,
                                    masterAttribute: masterAttribute,
                                }
                                return ret;
                            });

                            // Value -----------------------------------------
                            if (field && field?.values?.[0])
                                field.values[0].value = changeEvent.value!;

                            const nFieldSet = nGroupNumber;

                            // Visiblity Updates ----------------------------------
                            const graphChanges = parentVisibilityProcessor.processVisibilityOnAttributeChange(
                                props.state.data.config,
                                field,
                                fields,
                                fieldsMap,
                            );

                            // TODO refactor this to a helper function so you can call the second iteration with a TTL to avoid infinite loops 
                            // and also tap into emit events for the change tracking
                            graphChanges.forEach(eGraphChange => {
                                if (fields)
                                    if (eGraphChange.newVisibility === 0) {

                                        delete nFieldSet.fields[eGraphChange.index].visibility;

                                        // TODO refactor, unify all three and clean up
                                        // * Duplicated code, this has been duplicated in addUpdateAttributeSet, AttributeSetGridViewEditor.onChange, NonStandardGridViewEditor.onChange
                                        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/319161
                                        fields[eGraphChange.index].values.forEach(eachValue => {

                                            if (eGraphChange.attribute.bcbs_defaultvalue)
                                                switch (eGraphChange.masterAttribute.bcbs_attributetypecode) {

                                                    // ignore, nothing to do, since it is of type message
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Message(808900014)'].value:
                                                        break;

                                                    // ignore, nothing to do, since it is of type message
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Lookup(808900006)'].value:
                                                        throw new Error("Not implemented exception!")

                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Single Line of Text(808900008)'].value:
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Boolean(808900000)'].value:
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Option Set(808900007)'].value:
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Currency(808900002)'].value:
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Date(808900003)'].value:

                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Whole Number(808900010)'].value:
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Decimal(808900004)'].value:
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Percentage(808900005)'].value:

                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Costshare(808900001)'].value:
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Pharmacy Costshare(808900013)'].value:
                                                    case bcbs_config_masterattribute.bcbs_attributetypecode['Vision Costshare(808900012)'].value:
                                                        // blank string or no-value at all
                                                        if (
                                                            !eachValue.value ||
                                                            (eachValue.value.type === 'string' && eachValue.value.value === '')
                                                        ) {

                                                            const field = fields![eGraphChange.index];
                                                            const fieldValue = eachValue;

                                                            const value: FAM_TValue = friendlyValueToFlexibleFieldValue(
                                                                props.state.data.config,
                                                                eGraphChange.attribute.bcbs_defaultvalue!,
                                                                eGraphChange.attribute,
                                                                eGraphChange.masterAttribute,
                                                                null
                                                            );

                                                            setChangeTracker(xChange => {
                                                                const nChange: typeof xChange = { ...xChange };
                                                                nChange[field.configRef.id] = {
                                                                    field: field,
                                                                    fieldValue: structuredClone(fieldValue),
                                                                    value: value!,
                                                                }
                                                                return nChange;
                                                            });

                                                            fieldValue.value = value

                                                        }

                                                        break;

                                                    default:
                                                        break;
                                                }

                                        })
                                    }
                                    else {

                                        nFieldSet.fields[eGraphChange.index].visibility = eGraphChange.newVisibility
                                    }
                            });

                            const cancellationFields = CancellationFieldsByCategory[$cat_$group_number_id];

                            if (changeEvent.value && cancellationFields)
                                CalculateRunOutClaimsEndDate(
                                    props.state.data.json,
                                    cancellationFields,
                                    field,
                                    fieldsMap,
                                    (calculatedValue, fieledAttribute, fieldValue) => {
                                        // custom action
                                        fieldValue.value = calculatedValue;
                                    });

                            return nGroupNumber;
                        });
                    }
                }}
                firstPivotItem={[onRenderProperties]}
            />

        </div>
    }


    const onRenderProperties: IRenderFunction<IPanelProps> = (bodyProps, defaultRender) => {
        if (!groupNumber)
            return null;

        return <PivotItem
            headerText={"Properties"}
            key={"groupNumberProperties"}
            itemKey={"groupNumberProperties"}
        >
            <SectionItem
                title="General"
                variant={ESectionItemVariant.Drawer}
            >
                <ControlMask
                    label="CES Client Number"
                    defaultLocked={isBulk}
                >
                    <CESDropdown
                        value={groupNumber?.cesNumberRef ? { id: groupNumber.cesNumberRef.id, cesNumber: groupNumber.cesNumberRef.name, deactivated: false } : undefined}
                        disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.groupNumber.link_ces}
                        onChange={(option) => {
                            setGroupNumber(t => { return { ...t!, cesNumberRef: { id: option.id, name: option.cesNumber } } });
                        }}
                    />
                </ControlMask>

                <TextFieldControl
                    label={"Prefix"}
                    disabled={isBulk || props.disabled || !application.ChangeTypePermissions.groupStructure.groupNumber.modify_groupnumber}
                    fieldValueOnChange={(event, value) => {

                        setGroupNumber(t => {
                            return {
                                ...t!,
                                prefix: value.value ?? "",
                                groupNumber: calcGroupNumber(value.value ?? "", t?.base, t?.suffix)
                            };
                        })
                    }}
                    defaultFieldValue={{ type: 'string', value: groupNumber?.prefix ?? '' }}
                />

                <TextFieldControl
                    label={"Base"}
                    disabled={isBulk || props.disabled || !application.ChangeTypePermissions.groupStructure.groupNumber.modify_groupnumber}
                    fieldValueOnChange={(event, value) => {

                        setGroupNumber(t => {
                            return {
                                ...t!,
                                base: value.value ?? "",
                                groupNumber: calcGroupNumber(t?.prefix, value.value ?? "", t?.suffix)
                            };
                        })
                    }}
                    defaultFieldValue={{ type: 'string', value: groupNumber?.base ?? '' }}
                />


                <TextFieldControl
                    label={"Suffix"}
                    disabled={isBulk || props.disabled || !application.ChangeTypePermissions.groupStructure.groupNumber.modify_groupnumber}
                    fieldValueOnChange={(event, value) => {

                        setGroupNumber(t => {
                            return {
                                ...t!,
                                suffix: value.value ?? "",
                                groupNumber: calcGroupNumber(t?.prefix, t?.base, value.value ?? "")
                            };
                        })
                    }}
                    defaultFieldValue={{ type: 'string', value: groupNumber?.suffix ?? '' }}
                />


                <TextFieldControl
                    label={"Group Number"}
                    disabled={true}
                    defaultFieldValue={{
                        type: 'string',
                        value: groupNumber.groupNumber ?? ''
                    }}
                />

                <LookupControlBase
                    label='Plan'
                    disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.groupNumber.link_plan}
                    onLookup={() => { setIsPlanOpen(true) }}
                    onDelete={() => {
                        setGroupNumber(t => {
                            return { ...t!, planRef: null };
                        });
                    }}
                    value={groupNumber?.planRef?.name}
                />

                <LookupControlBase
                    label='Accounts Receivable'
                    disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.groupNumber.link_accountsreceivable}
                    onLookup={() => { setIsAROpen(true) }}
                    onDelete={() => {
                        setGroupNumber(t => {
                            return { ...t!, accountsReceivableRef: null };
                        });
                    }}
                    value={groupNumber?.accountsReceivableRef?.name}
                />

                <LookupControlBase
                    label='Stop Loss'
                    disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.groupNumber.link_stoploss}
                    onLookup={() => { setIsStopLossOpen(true) }}
                    onDelete={() => {
                        setGroupNumber(t => {
                            return { ...t!, stopLossRef: null };
                        });
                    }}
                    value={groupNumber?.stopLossRef?.name}
                />

                <ControlMask
                    label="Status"
                    defaultLocked={isBulk}
                >
                    <DropdownControl
                        label={"Status"}
                        disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.groupNumber.modify_status}
                        options={statusOptions}
                        selectedKey={groupNumber?.status?.value}
                        defaultValue={groupNumber?.status?.name}
                        onChange={(_, option?: IDropdownOption<FAM_TBenefitStatusOptionSetValue>) => {
                            setGroupNumber(xGroupNumber => {
                                const nGroupNumber = { ...xGroupNumber! };
                                nGroupNumber.status = option?.data!

                                applyVisibility(props.state.data.json,
                                    props.state.data.config,
                                    undefined,
                                    { groupNumber: nGroupNumber }
                                );

                                return nGroupNumber;
                            });
                        }}
                    />
                </ControlMask>

                <ControlMask
                    label="Deactivate"
                    defaultLocked={isBulk}
                    onUnlock={() => {
                        setGroupNumber(t => { return { ...t!, deactivated: false }; });
                    }}
                >
                    <ToggleControl
                        label={"Deactivate"}
                        disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.groupNumber.modify_deactivate}
                        checked={groupNumber.deactivated ?? false}
                        onChange={(_, checked) => {
                            setGroupNumber(t => { return { ...t!, deactivated: checked ?? false }; });
                        }}
                    />
                </ControlMask>

            </SectionItem>

        </PivotItem>
    }

    const onChange = (value: FAM_IGroupNumber) => {
        props.onChange?.(value);
    }

    const onRenderFooter: IRenderFunction<IPanelProps> = (bodyProps, defaultRender) => {
        return <div className={fadeIn}>
            <PrimaryButton text='OK'
                styles={panelButtonsStyles}
                disabled={(!isBulk && (!groupNumber?.cesNumberRef?.name || !groupNumber.prefix || !groupNumber.base || !groupNumber.suffix)) || props.disabled}
                onClick={async (event) => {
                    setSelfVisible(false);

                    setTimeout(() => {
                        if (groupNumber)
                            onChange(groupNumber);
                    }, 300);

                }}
            />
            <DefaultButton text="Cancel"
                styles={panelButtonsStyles}
                onClick={onDismiss}
            />
        </div>
    }

    // const onDetailListSelect = (selectedItems: FAM.IGroupNumber[]) => {
    //     if (selectedItems && selectedItems.length === 1) {
    //         // single items selected for edit?
    //         // lets only pick that single item and display for edit

    //         const item = selectedItems[0];
    //         setValue(structuredClone(item));

    //     } else if (selectedItems && selectedItems.length > 1) {
    //         // multiple items selected, lets create a a new blank template and use that for batch edit
    //         // later what ever changes that are done to this model we will cascade to selected items.

    //         const groupNumber: FAM.IGroupNumber = {
    //             id: 'batchEdit',
    //             cesNumberRef: null,
    //             prefix: null,
    //             suffix: null,
    //             groupNumber: null,
    //             base: null,
    //             fields: createDefaultCategoryFields(props.state.data.config, categoryGroupStructure, 'Group Structure', []),
    //             deactivated: false,
    //         };

    //         setValue(groupNumber);
    //     }
    // }

    return (
        <Panel
            isOpen={props.isOpen && selfVisible}
            onDismiss={onDismiss}
            type={PanelType.medium}
            headerText="Edit"
            isFooterAtBottom={true}
            onRenderFooterContent={onRenderFooter}
        >
            {onRenderBody()}
        </Panel>

    );
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(GroupStructureGroupNumberView);
